export default "__VITE_ASSET__jt214iYV__"